export default {
  steps: [], // Array de OnboardingStep
  progress: [], // Array de OnboardingProgress
  isExpanded: true, // Se a sidebar esta expandida
  isLoading: false,
  hasCompletedAll: false
}
